<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">
            Relatório de seguros
          </h6>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button
            @click="handleContratarClick"
            :disabled="!selectedRows.length"
            size="sm"
            type="neutral"
            >Contratar</base-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <base-input
            type="date"
            size="sm"
            v-model="formDate.startDate"
            value="2021-01-01"
            id="example-date-input"
          />
        </b-col>
        <b-col md="3">
          <base-input
            type="date"
            v-model="formDate.endDate"
            value="2021-01-28"
            id="example-date-input"
          />
        </b-col>
        <b-row>
          <b-col class="ml-3 pb-3">
            <button
              :disabled="selectedRows.length > 0"
              @click="fetchOrders"
              type="submit"
              class="btn btn-primary"
            >
              Buscar
            </button>
          </b-col></b-row
        >
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">Relatório de seguros</h3>
            <p class="text-sm mb-0">
              Acompanhe aqui seu relatório seguros .
            </p>
          </template>
          <div>
            <b-col
              cols="12"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <b-col class="pl-0" md="3">
                <multiselect
                  :multiple="true"
                  placeholder="Filtrar por..."
                  deselect-label="Remover"
                  select-label="Adicionar"
                  selected-label="Selecionado"
                  v-model="value"
                  :options="options"
                  :searchable="false"
                ></multiselect>
              </b-col>

              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                placeholder="Search..."
              >
              </base-input>
            </b-col>
            <el-table
              v-loading="loadingTable"
              ref="multipleTable"
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :selectable="canSelectRow"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando {{ from + 1 }} - {{ to }} de {{ total }} entradas

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import users from "../Tables/users2";

import janooService from "../../services/janoo/index";
import nodeService from "../../services/nodejs/index";
import axios from "axios";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data: () => {
    return {
      formDate: {
        startDate: "",
        endDate: ""
      },
      loadingTable: false,
      tableColumns: [
        {
          type: "selection"
        },
        {
          prop: "id",
          label: "id",
          width: 90,
          sortable: true
        },
        {
          prop: "seguradora",
          label: "Seguadora",
          width: 150,
          sortable: true
        },
        {
          prop: "data",
          label: "Inicio da Reserva",
          width: 240,
          sortable: true
        },
        {
          prop: "qnt",
          label: "Quantidade de Segurados",
          width: 280,
          sortable: true
        },
        {
          prop: "taxa",
          label: "Taxa",
          width: 120,
          sortable: true
        },
        {
          prop: "valor",
          label: "Valor",
          minWidth: 120,
          sortable: true
        },
        {
          prop: "status",
          label: "status",
          minWidth: 120,
          sortable: true
        }
      ],
      options: [
        {
          value: "Option1",
          label: "Option1"
        },
        {
          value: "Option2",
          label: "Option2"
        },
        {
          value: "Option3",
          label: "Option3"
        },
        {
          value: "Option4",
          label: "Option4"
        },
        {
          value: "Option5",
          label: "Option5"
        }
      ],
      value: [],
      tableData: [],
      selectedRows: []
    };
  },
  mounted() {
    this.fillsFormDate();
    this.fetchOrders();
    //this.formatArrayOrders();
  },

  methods: {
    canSelectRow(row, index) {
      return row.seguradora !== "Sem seguro";
    },
    handleContratarClick() {
      swal
        .fire({
          title: `Tem certeza?`,
          text: "Deseja realmente contratar os itens selecionados ?",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question"
        })
        .then(result => {
          if (result.isConfirmed) {
            const userSelectedRows = this.selectedRows.map(order => order.id);
            const value = this.selectedRows.reduce(
              (prev, curr) => curr.valor + prev,
              0
            );
            this.toggleSelection();
            this.contratar(userSelectedRows, value);
          }
        });
    },
    contratar(ids, value) {
      nodeService
        .contratarBookigs(ids, value)
        .then(function(response) {
          console.log("storeOrders reponse", response);
          swal.fire("Sucesso!", "Contrato realizado com Sucesso!", "success");
        })
        .catch(function(error) {
          console.log("Catch", error);
        });
    },
    formatArrayOrders(orders) {
      let ordersParse = JSON.parse(JSON.stringify(orders)); // descomentar quando em produção

      Object.values(ordersParse).forEach(element => {
        let itemArrayTable = {
          id: element.id,
          seguradora: getResourcesAttribute(element, "name"),
          qnt: getResourcesAttribute(element, "amount"),
          data: new Date(element.start * 1000).toLocaleString(),
          taxa: getResourcesAttribute(element, "price"),
          valor: getResourcesTotal(element),
          status: "Pendente"
        };
        this.tableData.push(itemArrayTable);
      });
      function getResourcesAttribute(element, attribute) {
        element = !element.resources
          ? "Sem seguro"
          : element.resources[0]
          ? element.resources[0][attribute]
          : "Sem seguro";
        return element;
      }

      function getResourcesTotal(element) {
        element = !element.resources
          ? "Sem seguro"
          : element.resources.total
          ? element.resources.total
          : "Sem seguro";
        return element;
      }

      this.createFuseSearch([
        "data",
        "status",
        "seguradora",
        "status",
        "taxa",
        "id"
      ]);
    },

    fetchOrders() {
      console.log("fetchin fetchOrders...");

      const { startDate, endDate } = this.formDate;

      var sDate = new Date(startDate);
      var eDate = new Date(endDate);

      if (sDate.getTime() > eDate.getTime()) {
        swal.fire({
          title: `Erro! datas inicial e final invalidas !`,
          text: `a data final deve ser após a data inicial !`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary"
        });
      }
      this.tableData = [];
      this.loadingTable = true;

      axios
        .get("//api.bocapio.com.br/api/v2/janoowp/bookings", {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-access-token": getTokenNode()
          }
        })
        .then(response => {
          // console.log("fetchOrders reponse", response);
          this.formatArrayOrders(response.data);
          this.formatArrayTableByPaymentMethod(response.data);
          this.loadingTable = false;
          this.loadingTableByPaymentMethod = false;
        })
        .catch(error => {
        // console.log("Catch", error);
          this.loadingTable = false;
          this.loadingTableByPaymentMethod = false;
        })
    },

    fillsFormDate() {
      let date = new Date();
      let firstDateMoth = new Date(date.getFullYear(), date.getMonth(), 1);
      let m = firstDateMoth.getMonth() + 1;
      let d = firstDateMoth.getDate();
      d = d > 9 ? d : "0" + d;
      m = m > 9 ? m : "0" + m;
      let formatedFirstDayMoth = date.getFullYear() + "-" + m + "-" + d;

      let todayDay = date.getDate();
      let todayMoth = date.getMonth() + 1;
      todayDay = todayDay > 9 ? todayDay : "0" + todayDay;
      todayMoth = todayMoth > 9 ? todayMoth : "0" + todayMoth;

      let foramtedToday = date.getFullYear() + "-" + todayMoth + "-" + todayDay;
      this.formDate.startDate = formatedFirstDayMoth;
      this.formDate.endDate = foramtedToday;
    },

    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    handleLike() {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.no-border-card .card-footer {
  border-top: 0;
}
</style>
